export const PRODUCTION_ORDERS_SELECT = [
  'CreatedBy',
  'ActualEndDate',
  'ActualStartDate',
  'CreatedOn',
  'CustomerDeliveryDate',
  'InternalDeliveryDate',
  'ModifiedOn',
  'ScheduledEndDate',
  'ScheduledStartDate',
  'Description',
  'PartDrawingNumber',
  'PartDrawingPosition',
  'PartDrawingRevision',
  'ModifiedBy',
  'ProductionOrderRowMemo',
  'IsActive',
  'PartDescription',
  'PartNumber',
  'ProductionOrderNumber',
  'QuantityPlanned',
  'RecipeNumber',
  'ProductionOrderId',
  'ImageHash',
  'ImageDocumentId',
  'ImageData',
];

export const OPERATION_SELECT = [
  'ProductionOperationId',
  'CreatedBy',
  'ActualEndDate',
  'ActualStartDate',
  'CreatedOn',
  'ModifiedOn',
  'ScheduledEndDate',
  'ScheduledStartDate',
  'OperationNumber',
  'ShortDescription',
  'PartDrawingNumber',
  'PartDrawingPosition',
  'PartDrawingRevision',
  'ModifiedBy',
  'LinkedNcFiles',
  // 'WorkplaceMachineName',
  'PartDescription',
  'PartNumber',
  'ProductionOrderNumber',
  'SetupTimeSeconds',
  'TotalTimeScheduledSeconds',
  'TotalTimeActualSeconds',
  // 'WorkplaceMemo',
  // 'WorkplaceName',
  // 'WorkplaceNumber',
  // 'WorkplaceType',
  'ProductionOrderId',
  'ImageDocumentId',
  'ImageHash',
  'ImageData',
  'ProductionOperationNumber',
  'OperationName',
  'Status',
  'Machines',
  'QuantityTarget',
  'QuantityProduced',
];

export const PART_SELECT = [
  'CreatedBy',
  'PartId',
  'ImageHash',
  'ImageDocumentId',
  'ImageData',
  'CreatedOn',
  'ModifiedOn',
  'Description',
  'Drawing',
  'DrawingRevisionPosition',
  'Position',
  'Revision',
  'ModifiedBy',
  'LinkedNcFiles',
  'PartName',
  'PartSearchName',
];

export const NC_FILE_SELECT = [
  'ChangeTimePerPcsSecond',
  'CreatedOn',
  'FirstRanByMachineName',
  'FirstRanOn',
  'LastRanByMachineName',
  'LastRanOn',
  'LinkedBy',
  'LinkedOn',
  // 'Links',
  'Memo',
  'NcFileId',
  'ImageData',
  'ImageDocumentId',
  'ImageHash',
  'NcFileName',
  'NcFileStatus',
  'NcFileStatusSetBy',
  'NcFileStatusSetOn',
  'PartDescription',
  'PartDrawingNumber',
  'PartDrawingPosition',
  'PartDrawingRevision',
  'PartId',
  'PartNumber',
  'RunTimePerPcsSecond',
  'SetupSheet',
  'SetupTimeSecond',
  'LinksSummary',
  // 'Versions',
];

export const IMAGES_DOCUMENTS_SELECT = [
  "ContentHash",
  "CreatedBy",
  "CreatedOn",
  "DerivativesConversionStatus",
  "DocumentId",
  "DocumentRetrievalStatus",
  "DocumentType",
  "ExtensionDerivative",
  "ExtensionOriginal",
  "FileName",
  "FilePath",
  "FileSize",
  "ImageCropSettings",
  "ImageDetails",
  "IsCropped",
  "MediaTypeDerivative",
  "MediaTypeOriginal",
  "ModifiedBy",
  "ModifiedOn",
  "PageCount",
  "PageNumber",
  "Source",
  "SourceName",
  "SubTitle",
  "Tags",
  "Title",
];

export const PLANBOARD_OPERATION_SELECT = [
  'ProductionOperationId',
  'ProductionOperationNumber',
  'ProductionOrderId',
  'OperationName',
  'PartDescription',
  'Status',
  'ScheduledStartDate',
  'ExpectedStartOn',
  'TotalTimeScheduledSeconds',
  'TotalTimeActualSeconds',
  'SetupTimeSeconds',
  'QuantityProduced',
  'QuantityTarget',
  'ImageDocumentId',
  'ImageHash',
  'ImageData',
  'LinkedNcFiles',
  'ActualStartDate',
  'ScheduledEndDate',
  'ElapsedTimeSeconds',
  'Machines',
  'HasPriorityOverride',
  'ScheduledStartDateOverride',
  'CustomerName',
  'ActualEndDate',
  'ProductionOrderNumber',
];

